<div class="nav-top">
    <div class="item" [ngClass]="{'item-active':activeRoute=='list'}" (click)="goto('list')">All</div>
    <div class="item" [ngClass]="{'item-active':activeRoute=='search'}" (click)="goto('search')">Search</div>
</div>
<router-outlet></router-outlet>